export const devOriginList = [
    'urlaub.test',
    'check24-test.de',
    'urlaub-at.test',
    'check24-test.at',
];

export const prodOriginList = [
    '^.*(?<!www.)check24.de',
    '^.*(?<!www.)check24.at',
];

export const blockList = {
    maskCSSIdentifiers: ['#c24kb-customer-area-menu'],
    blockUrlIdentifiers: ['buchung'],
};

export const defaultSamplingRate = 0.1;

export const dsn =
    'https://6edebee72f7a4c5287a1379a22de489b@o1170341.ingest.sentry.io/6263809';

export const ignoreErrors = [
    '**/*.chunk.js)',
    '**currentTarget, detail, isTrusted, target',
    '**insertBefore**',
    '**NetworkError**',
    '**/c24-pbe-polyfills)',
    '**/combined/**',
    '**/jquery**',
    '**(maps-api-v3/**',
    '*.js-**',
    '*Check24 is not defined*',
    '*Maximum call stack size exceeded*',
    '*NodeType*',
    '*recursion',
    '*removeChild*',
    '*Speicherplatz*',
    'AbortController*',
    'AbortError',
    'AbortError*',
    'CSS_CHUNK_LOAD_FAILED',
    'ChunkLoadError',
    'ConnectionError',
    'Error: Failed to load',
    'Failed to fetch',
    'Importing a module script failed',
    'jQuery is not defined',
    'No response from window - cleaned up',
    'SyntaxError ?(portal/combined/urlaub/default)',
    'TypeError: Cancelled',
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
    'TypeError: window.cobrowseIOgetRedactedElementsBounds is not a function.',
];
